module.exports = __webpack_public_path__ + "14four/static/media/CameraTargetIndicator.fe1b4ab2.svg";